<script setup lang="ts">
import VListItem from "@magnit/core/src/components/VListItem/VListItem.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import VText from "@magnit/core/src/components/VText/VText.vue";
import VRadio from "@magnit/core/src/components/VRadio/VRadio.vue";
import SaleIcon from "@magnit/icons/src/assets/icons/sale-24-duoton.svg";
import MenuSquareIcon from "@magnit/icons/src/assets/icons/menu-square-24-duoton.svg";
import type { ICategory } from "@magnit/unit-catalog/src/unit-catalog.types";
import { inject, ref, type Ref } from "vue";
import { provideKeys } from "../constants";

defineProps<{
  category: ICategory;
  showIcon?: boolean;
}>();

const promoGoodsKey = inject<Ref<string>>(provideKeys.promoGoodsKey, ref(""));

const goodsKey = inject<Ref<string>>(provideKeys.goodsKey, ref(""));

const modelValue = defineModel<ICategory["key"]>({ default: "" });
</script>

<template>
  <label :for="category.key" class="filters-category-mobile-item">
    <VListItem :divider="false" valign="center">
      <template
        v-if="showIcon && [goodsKey, promoGoodsKey].includes(category.key)"
        #left
      >
        <VIcon>
          <SaleIcon v-if="category.key === promoGoodsKey" />
          <MenuSquareIcon v-else />
        </VIcon>
      </template>
      <VText :font="category.parentKey ? 'body-large-regular' : 'title-medium'"
        >{{ category.name }}
      </VText>
      <template #right>
        <VRadio
          :id="category.key"
          v-model="modelValue"
          :value="category.key"
          wrapper-class="filters-category-mobile-item__input"
        />
      </template>
    </VListItem>
  </label>
</template>

<style lang="postcss" scoped>
.filters-category-mobile-item {
  display: flex;
  flex-direction: column;

  &__input {
    padding: var(--pl-unit-x2) 0;
  }
}
</style>
